import { Stack } from '@mantine/core';
import { useState } from 'react';
import { useAdherenceLogs } from '../../../api/events-client/events-client.hooks';
import { type AdherenceLog } from '../../../api/events-client/events-client.type';
import { FilterPanel } from '../../../components/filters/filter-panel';
import { BrandedLoadingOverlay } from '../../../components/loader/branded-loader';
import { PageLayout } from '../../../components/page-layout/page-layout';
import { useGlobalStore } from '../../../store/global-store/global-store';
import { AdherenceLogSideSection } from './components/adherence-log-side-section';
import { AdherenceLogsTable } from './components/adherence-logs-table';
import { getFilterGroups } from './filters/adherence-logs-filter-groups.helpers';
import { useAdherenceLogsFilters } from './filters/adherence-logs-filters.hooks';

export const MissedEvents = () => {
  const organizationId = useGlobalStore((state) => state.organization?.id);
  const [selectedLog, setSelectedLog] = useState<AdherenceLog | null>(null);

  const filters = useAdherenceLogsFilters();

  const { data: adherenceLogs, query } = useAdherenceLogs(organizationId, filters.getSelectedEventTypes());

  const handleAdherenceLogClick = (log: AdherenceLog) => {
    setSelectedLog(log);
  };

  const handleCloseSideSection = () => {
    setSelectedLog(null);
  };

  const filterGroups = getFilterGroups(filters.eventTypeFilters, filters.setEventTypeFilters);

  const mainContent = (
    <Stack style={{ height: '100%', position: 'relative' }}>
      <BrandedLoadingOverlay visible={query.isLoading} variant="colored" />
      <AdherenceLogsTable adherenceLogs={adherenceLogs} onAdherenceLogClick={handleAdherenceLogClick} />
    </Stack>
  );

  return (
    <PageLayout
      sideFilters={{
        content: <FilterPanel filterGroups={filterGroups} onResetFilters={filters.handleResetFilters} />,
      }}
      controlBar={undefined}
      mainSection={mainContent}
      sideSection={<AdherenceLogSideSection adherenceLog={selectedLog} onClose={handleCloseSideSection} />}
      showSideSection={!!selectedLog}
    />
  );
};
